
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/publishers/[slug]",
      function () {
        return require("private-next-pages/publishers/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/publishers/[slug]"])
      });
    }
  